import React, { lazy } from 'react'

const AssetsAdditionalFieldSettingDetailListing = lazy(() =>
  import('./AssetsAdditionalFieldSettingListing').then(module => ({
    default: module.AssetsAdditionalFieldSettingDetailListing,
  }))
)
const AssetsAdditionalFieldSettingTemplateListing = lazy(() =>
  import('./AssetsAdditionalFieldSettingTemplateListing').then(module => ({
    default: module.AssetsAdditionalFieldSettingTemplateListing,
  }))
)

const assetsAdditionalFieldSettingRoutes = [
  {
    props: {
      exact: true,
      path: '/fixed-assets/general-setting/assets-additional-field-setting',
    },
    component: <AssetsAdditionalFieldSettingTemplateListing />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/general-setting/assets-additional-field-setting/:assetFieldSettingID/assets-field-setting-detail',
    },
    component: <AssetsAdditionalFieldSettingDetailListing />,
  },
]

export default assetsAdditionalFieldSettingRoutes
